const MoneyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6.75C2 5.7835 2.7835 5 3.75 5H17.25C18.2165 5 19 5.7835 19 6.75V15.25C19 16.2165 18.2165 17 17.25 17H3.75C2.7835 17 2 16.2165 2 15.25V6.75ZM5 6.25V7.25C5 7.66421 4.66421 8 4.25 8H3.25V9.5H4.25C5.49264 9.5 6.5 8.49264 6.5 7.25V6.25H5ZM10.5 13.5C11.7426 13.5 12.75 12.4926 12.75 11.25C12.75 10.0074 11.7426 9 10.5 9C9.25736 9 8.25 10.0074 8.25 11.25C8.25 12.4926 9.25736 13.5 10.5 13.5ZM3.25 14H4.25C4.66421 14 5 14.3358 5 14.75V15.75H6.5V14.75C6.5 13.5074 5.49264 12.5 4.25 12.5H3.25V14ZM16 14.75C16 14.3358 16.3358 14 16.75 14H17.75V12.5H16.75C15.5074 12.5 14.5 13.5074 14.5 14.75V15.75H16V14.75ZM16 7.25V6.25H14.5V7.25C14.5 8.49264 15.5074 9.5 16.75 9.5H17.75V8H16.75C16.3358 8 16 7.66421 16 7.25ZM4.40135 18.5C4.92006 19.3967 5.88958 20 7 20H17.25C19.8734 20 22 17.8734 22 15.25V10C22 8.88958 21.3967 7.92006 20.5 7.40135V15.25C20.5 17.0449 19.0449 18.5 17.25 18.5H4.40135Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MoneyIcon;
